import * as React from "react";
import { Link, useParams } from "react-router-dom";
//Services
import { read } from "helpers/localStorage";
// UI frameworks
import { Result } from "antd";

const BankResult: React.FC = props => {
	const { status } = useParams();
	const [isSuccess, setIsSuccess] = React.useState(false);
	// const timeOutRef = React.useRef();

	React.useEffect(() => {
		setIsSuccess(status === "success");

		// if (read("callbackURI")) {
		// 	// @ts-ignore
		// 	timeOutRef.current = setTimeout(() => {
		// 		remove("callbackURI");
		// 	}, 5000);
		// }
		// return () => {
		// 	clearTimeout(timeOutRef.current);
		// };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return isSuccess ? (
		read("callbackURI") ? (
			<Result
				status="success"
				title="پرداخت قسط شما با موفقیت انجام شد."
				extra={[
					<Link to="/dashboard/reports" key="successReport" className="ant-btn">
						بازگشت به صفحه اقساط
					</Link>,
				]}
			/>
		) : (
			<Result
				status="success"
				title="افزایش حساب کاربری شما با موفقیت انجام شد."
				extra={[
					<Link to="/dashboard" key="backToHome" className="ant-btn">
						بازگشت به صفحه اصلی
					</Link>,
				]}
			/>
		)
	) : (
		<Result
			status="error"
			title="پرداخت با مشکل مواجه شد."
			extra={[
				// <Link to="/dashboard/reports" key="InstallmentFail" className="ant-btn">
				// 	بازگشت به صفحه اقساط
				// </Link>,
				<Link to="/dashboard" key="FundFail" className="ant-btn">
					بازگشت به صفحه اصلی
				</Link>,
			]}
		/>
	);
};

export default BankResult;
